// import { useState, useRef, useEffect } from "react";
// import Button from "../../components/updatedComponents/Dealers/Button";
// import { NewEyeIcon } from "../../components/icons/Icon";

// const MoreDropdown = ({ mode, onSummaryClick, onSlipClick }) => {
//   const [open, setOpen] = useState(false);
//   const dropdownRef = useRef(null);

//   const styles = getStyles(mode);

//   // ✅ Outside click close
//   useEffect(() => {
//     const handleClickOutside = (e) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
//         setOpen(false);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   return (
//     <div ref={dropdownRef} style={styles.wrapper}>
//       <Button
//         buttonIcon={<NewEyeIcon />}
//         buttonText={"More"}
//         buttonBgColor={"#000000"}
//         buttonTextColor={"#ffffff"}
//         buttonClick={() => setOpen((prev) => !prev)}
//       />

//       {open && (
//         <div
//           style={{
//             ...styles.dropdown,
//             opacity: open ? 1 : 0,
//             transform: open ? "translateY(0)" : "translateY(10px)",
//             transition: "all 0.2s ease",
//           }}
//         >
//           <div
//             style={styles.item}
//             onClick={() => {
//               onSummaryClick?.();
//               setOpen(false);
//             }}
//             onMouseEnter={(e) =>
//               (e.currentTarget.style.background = styles.hoverBg)
//             }
//             onMouseLeave={(e) =>
//               (e.currentTarget.style.background = "transparent")
//             }
//           >
//             Master Summary
//           </div>

//           <div
//             style={styles.item}
//             onClick={() => {
//               onSlipClick?.();
//               setOpen(false);
//             }}
//             onMouseEnter={(e) =>
//               (e.currentTarget.style.background = styles.hoverBg)
//             }
//             onMouseLeave={(e) =>
//               (e.currentTarget.style.background = "transparent")
//             }
//           >
//             Master Slip
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// const getStyles = (mode) => ({
//   wrapper: {
//     position: "relative",
//     display: "inline-block",
//   },

//   dropdown: {
//     position: "absolute",
//     bottom: "50px",
//     right: 0,
//     backgroundColor: mode ? "#1B1D21" : "#ffffff",
//     border: mode ? "1px solid #2A2D33" : "1px solid #e5e7eb",
//     borderRadius: "8px",
//     padding: "6px",
//     minWidth: "180px",
//     zIndex: 1000,
//   },

//   item: {
//     padding: "10px 12px",
//     cursor: "pointer",
//     borderRadius: "6px",
//     fontSize: "14px",
//     color: mode ? "#E5E7EB" : "#111827",
//     transition: "background 0.2s ease",
//   },

//   hoverBg: mode ? "#2A2D33" : "#f3f4f6",
// });

// export default MoreDropdown;

import { useState, useRef, useEffect } from "react";
import { NewEyeIcon, Printers } from "../../components/icons/Icon";

const MoreDropdown = ({ mode, onSummaryClick, onSlipClick, isSuperAdmin }) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  const styles = getStyles(mode);

  // ✅ Outside click close
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div ref={dropdownRef} style={styles.wrapper}>
      <button
        onClick={() => setOpen((prev) => !prev)}
        style={styles.glassButton}
      >
        {/* <NewEyeIcon /> */}
        <Printers color="#FFFFFF" />
      </button>

      {open && (
        <div
          style={{
            ...styles.dropdown,
            opacity: open ? 1 : 0,
            transform: open ? "translateY(0)" : "translateY(10px)",
            transition: "all 0.2s ease",
          }}
        >
          <div
            style={styles.item}
            onClick={() => {
              onSummaryClick?.();
              setOpen(false);
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.background = styles.hoverBg)
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.background = "transparent")
            }
          >
            🧾 Master Summary
          </div>

          {isSuperAdmin && (
            <div
              style={styles.item}
              onClick={() => {
                onSlipClick?.();
                setOpen(false);
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.background = styles.hoverBg)
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.background = "transparent")
              }
            >
              🧾 Summary
            </div>
          )}
        </div>
      )}
    </div>
  );
};

const getStyles = (mode) => ({
  wrapper: {
    position: "relative",
    display: "inline-block",
  },

  glassButton: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "10px 14px",
    borderRadius: "8px",
    border: mode ? "1px solid #2A2D33" : "1px solid #e5e7eb",
    background: "#000000",
    color: "#E5E7EB",
    cursor: "pointer",
    transition: "all 0.2s ease",
    fontSize: "14px",
    fontWeight: "500",
  },

  dropdown: {
    position: "absolute",
    bottom: "50px",
    right: 0,
    backgroundColor: mode ? "#1B1D21" : "#ffffff",
    border: mode ? "1px solid #2A2D33" : "1px solid #e5e7eb",
    borderRadius: "10px",
    padding: "6px",
    minWidth: "200px",
    // zIndex: 1000,
    // boxShadow: mode
    //   ? "0 8px 20px rgba(0,0,0,0.5)"
    //   : "0 6px 14px rgba(0,0,0,0.1)",
  },

  item: {
    padding: "10px 12px",
    cursor: "pointer",
    borderRadius: "6px",
    fontSize: "14px",
    color: mode ? "#E5E7EB" : "#111827",
    transition: "background 0.2s ease",
  },

  hoverBg: mode ? "#2A2D33" : "#f3f4f6",
});

export default MoreDropdown;
